import { axiosClient } from "./axiosClient";
import { AUTH_ENDPOINTS } from "./endpoints";
import { TriggerOtpRequest, VerifyOtpRequest } from "./api.types";


export const triggerOtpApi = async (payload: TriggerOtpRequest) => {
    const res = await axiosClient.post(
        AUTH_ENDPOINTS.TRIGGER_OTP,
        payload
    );
    return res.data;
};

export const verifyOtpApi = async (payload: VerifyOtpRequest) => {
    const res = await axiosClient.post(
        AUTH_ENDPOINTS.VERIFY_OTP,
        payload
    );
    return res.data;
};

export const verifyPinApi = async (payload: any) => {
    const res = await axiosClient.post(
        AUTH_ENDPOINTS.LOGIN,
        payload
    );
    return res.data;
};

export const setPinApi = async (payload: any) => {
    const res = await axiosClient.post(
        AUTH_ENDPOINTS.SET_PIN,
        payload
    );
    return res.data;
};
export const logoutApi = async (payload: any) => {
    const res = await axiosClient.post(
        AUTH_ENDPOINTS.LOGOUT,
        payload
    );
    return res.data;
};
